import { getConfig } from '../config/config';
import { getKeycloakInstance } from '../config/keycloak';
import { ResponseV3 } from '../constants/types';
import { getTenant } from '../utils/getKeycloakConfig';
import makeRequest from './makeRequest';

const incrementPageCounter = async (
  pageName: string,
): Promise<ResponseV3<boolean>> => {
  const url = `${
    getConfig().excelEngineApiEndpoint
  }/${getTenant()}/api/v3/analytics/increment/page/${pageName}`;
  const headers = {
    Authorization: `Bearer ${getKeycloakInstance()?.token}`,
  };

  try {
    const { data } = await makeRequest('POST', url, '', headers);
    return data;
  } catch (error: any) {
    throw error?.response;
  }
};
export { incrementPageCounter };
